import { getFormattedCosts } from '@/utils'

export const reportsList = [
  {
    id: 'new_report_1',
    url: 'customer_incoming_report?',
    name: 'Планируемые приходы от Заказчика',
    companySelect: true,
    datesSelect: true,
    statusSelect: true,
    managerSelect: true,
    fieldManagerSelect: true,
    summaryColumns: null
  },
  {
    id: 'new_report_2',
    url: 'customer_payments_report?',
    name: 'Фактические платежи от Заказчика (список платежей)',
    companySelect: true,
    datesSelect: true,
    statusSelect: true,
    managerSelect: true,
    fieldManagerSelect: true,
    summaryColumns: [5]
  },
  {
    id: 'new_report_3',
    url: 'customer_payments_grouped_report?',
    name: 'Фактические платежи от Заказчика (по проектам)',
    companySelect: true,
    datesSelect: true,
    statusSelect: true,
    managerSelect: true,
    fieldManagerSelect: true,
    summaryColumns: [4, 5]
  },
  {
    id: 'new_report_5',
    url: 'kp_check_report?',
    name: 'Непривязанные этапы проектов - подрядчиков',
    companySelect: true,
    datesSelect: false,
    performerSelect: false,
    managerSelect: true,
    fieldManagerSelect: true,
    summaryColumns: null
  },
  {
    id: 'new_report_6',
    url: 'conclusion_report?',
    name: 'Задачи по получению отзывов',
    companySelect: true,
    datesSelect: false,
    summaryColumns: null,
    downloadFiles: true
    // statusField: 'conclusion'
  },
  {
    id: 'new_report_7',
    url: 'expertise_report?',
    name: 'Задачи по получению заключений экспертизы',
    companySelect: true,
    datesSelect: false,
    summaryColumns: null,
    downloadFiles: true
    // statusField: 'expertise'
  },
  {
    id: 'new_report_8',
    url: 'report_8?',
    name: 'Проекты - подрядчики',
    companySelect: true,
    datesSelect: false,
    performerSelect: true,
    summaryColumns: null,
    parentSelect: true,
    managerSelect: true,
    fieldManagerSelect: true
  },
  {
    id: 'all_document_report',
    url: 'all_document_report?',
    name: 'Проверка загруженных документов',
    statusSelect: true,
    companySelect: true,
    onlyErrorSetting: true,
    managerSelect: true,
    fieldManagerSelect: true
  },
  {
    id: 'signed_project_report',
    url: 'signed_project_report?',
    name: 'Отчет по проектам',
    datesSelect: true,
    companySelect: true,
    managerSelect: true,
    fieldManagerSelect: true
  },
  {
    id: 'act_report',
    url: 'act_report?',
    name: 'Отчет по актам',
    companySelect: true
  },
  {
    id: 'income_plan_fact_report',
    url: 'income_plan_fact_report?',
    name: 'План-факт по поступлениям от Заказчика',
    datesSelect: true,
    companySelect: true,
    managerSelect: true,
    fieldManagerSelect: true
  },
  {
    id: 'bg_report',
    url: 'bg_report?',
    name: 'Отчет по банковским гарантиям',
    companySelect: true
  }
]

export const reportsConfigs = {
  new_report_1: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Шифр объекта',
      key: 'code',
      align: 'center',
      sortable: true
    },
    {
      title: 'Заказчик',
      key: 'customer_name',
      width: 224,
      align: 'center',
      sortable: true
    },
    {
      title: 'Исполнитель',
      key: 'performer_name',
      width: 224,
      align: 'center',
      sortable: true
    },
    {
      title: 'Долг по актам',
      key: 'act_dept',
      align: 'center',
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.act_dept, true))
      }
    },
    {
      title: 'Долг по платежам',
      key: 'payed_dept',
      align: 'center',
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.payed_dept, true))
      }
    },
    {
      title: '...',
      slot: 'action',
      width: 60,
      align: 'center',
      fixed: 'right'
    }
  ],
  new_report_2: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Шифр объекта',
      key: 'contract_code',
      align: 'center',
      sortable: true
    },
    {
      title: 'Заказчик',
      key: 'customer_name',
      width: 224,
      align: 'center',
      sortable: true
    },
    {
      title: 'Исполнитель',
      key: 'performer_name',
      width: 224,
      align: 'center',
      sortable: true
    },
    {
      title: 'Дата',
      key: 'date',
      align: 'center'
    },
    {
      title: 'Сумма',
      key: 'value',
      align: 'center',
      width: 240,
      sortable: true,
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.value, true))
      }
    },
    {
      title: '...',
      slot: 'action',
      width: 60,
      align: 'center',
      fixed: 'right'
    }
  ],
  new_report_3: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Шифр объекта',
      key: 'contract_code',
      align: 'center',
      sortable: true
    },
    {
      title: 'Заказчик',
      key: 'customer_name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Исполнитель',
      key: 'performer_name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Общая сумма приходов',
      key: 'already_payed',
      align: 'center',
      sortable: true,
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.already_payed, true))
      }
    },
    {
      title: 'Общая сумма оставшихся платежей',
      key: 'need_to_pay',
      align: 'center',
      sortable: true,
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.need_to_pay, true))
      }
    },
    {
      title: 'Общая сумма оставшихся платежей (в %)',
      key: 'need_to_pay_part',
      align: 'center',
      sortable: true
    },
    {
      title: '...',
      slot: 'action',
      width: 60,
      align: 'center',
      fixed: 'right'
    }
  ],
  new_report_5: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Шифр объекта',
      key: 'code',
      align: 'center',
      sortable: true
    },
    {
      title: 'Заказчик',
      key: 'customer_name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Исполнитель',
      key: 'performer_name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Непривязанный этап',
      key: 'error_roadmaps',
      align: 'center',
      sortable: true
    },
    {
      title: '...',
      slot: 'action',
      width: 60,
      align: 'center',
      fixed: 'right'
    }
  ],
  new_report_6: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Шифр объекта',
      key: 'contract_code',
      align: 'center',
      sortable: true
    },
    {
      title: 'Наименование объекта',
      key: 'contract_name',
      align: 'center',
      sortable: true
    },
    // {
    //   title: 'Планируемая дата получения',
    //   key: 'receive_plan_date',
    //   align: 'center',
    //   render: (h, params) => {
    //     return h(
    //       'span',
    //       params.row.receive_plan_date
    //         ? formatDefaultDate(params.row.receive_plan_date)
    //         : 'Задача отсутствует'
    //     )
    //   }
    // },
    // {
    //   title: 'Фактическая дата получения',
    //   key: 'receive_fact_date',
    //   align: 'center',
    //   render: (h, params) => {
    //     return h(
    //       'span',
    //       params.row.receive_fact_date
    //         ? formatDefaultDate(params.row.receive_fact_date)
    //         : 'Задача отсутствует'
    //     )
    //   }
    // },
    {
      title: 'Текущий статус',
      key: 'problem_comment',
      align: 'center'
    },
    {
      title: '...',
      slot: 'action',
      width: 60,
      align: 'center',
      fixed: 'right'
    }
  ],
  new_report_7: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Заказчик',
      key: 'customer_name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Наименование объекта',
      key: 'contract_name',
      align: 'center',
      sortable: true
    },
    // {
    //   title: 'Планируемая дата получения',
    //   key: 'receive_plan_date',
    //   align: 'center',
    //   render: (h, params) => {
    //     return h(
    //       'span',
    //       params.row.receive_plan_date
    //         ? formatDefaultDate(params.row.receive_plan_date)
    //         : 'Задача отсутствует'
    //     )
    //   }
    // },
    // {
    //   title: 'Фактическая дата получения',
    //   key: 'receive_fact_date',
    //   align: 'center',
    //   render: (h, params) => {
    //     return h(
    //       'span',
    //       params.row.receive_fact_date
    //         ? formatDefaultDate(params.row.receive_fact_date)
    //         : 'Задача отсутствует'
    //     )
    //   }
    // },
    {
      title: 'Текущий статус',
      key: 'problem_comment',
      align: 'center'
    },
    {
      title: '...',
      slot: 'action',
      width: 60,
      align: 'center',
      fixed: 'right'
    }
  ],
  new_report_8: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Контрагент',
      key: 'performer_name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Шифр объекта',
      key: 'contract_code',
      align: 'center',
      sortable: true
    },
    {
      title: 'НДС',
      key: 'with_vat',
      align: 'center',
      render: (h, params) => {
        return h(
          'span',
          params.row.with_vat
            ? 'с НДС'
            : 'без НДС'
        )
      }
    },
    {
      title: 'Стоимость подписанных актов',
      key: 'sigh_acts_costs',
      align: 'center',
      width: 240,
      sortable: true,
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.sigh_acts_costs, true))
      }
    },
    {
      title: 'Общая сумма платежей',
      key: 'payments',
      align: 'center',
      width: 240,
      sortable: true,
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.payments, true))
      }
    },
    {
      title: '...',
      slot: 'action',
      width: 60,
      align: 'center',
      fixed: 'right'
    }
  ],
  all_document_report: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Договор',
      key: 'contract_name',
      width: 224,
      align: 'center',
      sortable: true
    },
    {
      title: 'Наименование объекта',
      key: 'name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Заказчик',
      key: 'customer_name',
      width: 224,
      align: 'center',
      sortable: true
    }
  ],
  signed_project_report: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Шифр объекта',
      key: 'code',
      align: 'center',
      sortable: true
    },
    {
      title: 'Заказчик',
      key: 'customer_name',
      width: 224,
      align: 'center',
      sortable: true
    },
    {
      title: 'Исполнитель',
      key: 'performer_name',
      width: 224,
      align: 'center',
      sortable: true
    },
    {
      title: 'Стоимость работ',
      key: 'costs',
      align: 'center',
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.costs, true))
      }
    },
    {
      title: '...',
      slot: 'action',
      width: 60,
      align: 'center',
      fixed: 'right'
    }
  ],
  act_report: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Акт',
      key: 'act',
      align: 'center',
      sortable: true,
      render: (h, params) => {
        return h('span', `${params.row.act_no} от ${params.row.act_date}`)
      }
    },
    {
      title: 'Договор',
      key: 'contract_code',
      align: 'center',
      sortable: true
    },
    {
      title: 'Исполнитель',
      key: 'performer_name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Сумма акта',
      key: 'act_cost',
      align: 'center',
      sortable: true,
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.act_cost, true))
      }
    },
    {
      title: 'Оплачено',
      key: 'payed_costs',
      align: 'center',
      sortable: true,
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.payed_costs, true))
      }
    },
    {
      title: 'Осталось к оплате',
      key: 'left_costs',
      align: 'center',
      sortable: true,
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.left_costs, true))
      }
    },
    {
      title: 'Статус',
      key: 'status',
      align: 'center',
      sortable: true
    }
  ],
  income_plan_fact_report: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Шифр объекта',
      key: 'code',
      align: 'center',
      width: 224,
      sortable: true
    },
    {
      title: 'Договор',
      key: 'contract_code',
      align: 'center',
      sortable: true
    },
    {
      title: 'Менеджер',
      key: 'manager_fio',
      align: 'center',
      sortable: true,
      render: (h, params) => {
        return h('span', params.row.manager_fio || 'Не указан')
      }
    },
    {
      title: 'Сумма договора',
      key: 'contract_cost',
      align: 'center',
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.contract_cost, true))
      }
    },
    {
      title: 'Общая сумма приходов',
      key: 'fact_income',
      align: 'center',
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.fact_income, true))
      }
    }
  ],
  bg_report: [
    {
      key: 'index',
      title: '№',
      width: 60,
      align: 'center'
    },
    {
      title: 'Номер',
      key: 'code',
      align: 'center',
      width: 224,
      sortable: true
    },
    {
      title: 'Договор',
      key: 'contract_number',
      align: 'center',
      sortable: true
    },
    {
      title: 'Тип БГ',
      key: 'type_name',
      align: 'center',
      sortable: true
    },
    {
      title: 'Начало',
      key: 'start_date',
      align: 'center',
      sortable: true
    },
    {
      title: 'Окочание',
      key: 'end_date',
      align: 'center',
      sortable: true
    },
    {
      title: 'Статус',
      key: 'status',
      align: 'center',
      sortable: true
    },
    {
      title: 'Сумма',
      key: 'amount',
      align: 'center',
      render: (h, params) => {
        return h('span', getFormattedCosts(params.row.amount, true))
      }
    }
  ]
}

export const modifyFilesData = data =>
  data.map(c => {
    const stats = c.files_arr.reduce((prev, el) => {
      prev[`${el[1]}`] = el[2]

      return prev
    }, {})

    return {
      ...c,
      ...stats
    }
  })

const getDataWithIndex = (data) => data.map((p, i) => ({
  ...p,
  index: i + 1
}))

export const modifyData = (id, data) => {
  switch (id) {
    case 'report_7':
      return modifyFilesData(getDataWithIndex(data))
    default:
      return getDataWithIndex(data)
  }
}

export const getAdditionalFilesColumns = data => {
  const keys = data[0].files_arr.map(el => `${el[1]}`)

  return [
    ...reportsConfigs.report_7,
    ...keys.map(key => ({
      title: key,
      align: 'center',
      width: 120,
      className: 'reports-files-col',
      render: (h, params) => {
        return h(
          'span',
          {
            class: {
              'reports-files-cell': true,
              'reports-files-cell-true': params.row[key],
              'reports-files-cell-false': !params.row[key]
            }
          }
        )
      },
      key
    }))
  ]
}
